<template>
  <div id="a-pricing-strategy-strategies">
    <a-base-component :subscribed_modules="subscribed_modules">
      <template v-slot:default>
        <v-row class="mt-2">
          <v-col cols="12" class="font-weight-bold">
            {{ $t("Plan_strategy_each_day") }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-space-between align-center">
            <v-text-field
              v-model="search"
              rounded
              outlined
              dense
              clearable
              solo
              flat
              hide-details
              prepend-inner-icon="mdi-magnify"
              :placeholder="$t('Search_strategy')"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn
              :loading="loadingAddStrategy"
              color="secondary"
              rounded
              @click="showAddStrategy()"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t("New_strategy") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="filteredStrategies.length > 0" class="mb-4">
          <v-col
            v-for="strategy in filteredStrategies"
            :key="strategy.id"
            cols="12"
            class="pb-0"
          >
            <v-card
              @click="routeToStrategyDetail(strategy.id)"
              class="strategy-card"
            >
              <v-card-text class="py-0">
                <v-row>
                  <v-col cols="12" md="3" class="d-flex align-center">
                    <v-avatar size="20" :color="strategy.color"></v-avatar>
                    <span class="ml-2">{{ strategy.name }}</span>
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex align-center">
                    <div class="text-uppercase font-weight-bold">
                      {{ getStrategyRatesCode(strategy.rate_plan_id) }}
                    </div>
                    <div class="ml-6 d-flex align-center">
                      <v-avatar size="20" color="#5D5D5D" class="white--text">
                        {{ strategy.num_rules ? strategy.num_rules : 0 }}
                      </v-avatar>
                      <div class="font-weight-bold ml-2">
                        {{ $t("Rules_applied") }}
                      </div>
                    </div>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    class="d-flex align-center"
                    style="gap: 10px;"
                  >
                    <v-chip small outlined color="green">
                      {{ $t("Used_in") }}
                      {{
                        strategy.num_calendar_assignments
                          ? strategy.num_calendar_assignments
                          : 0
                      }}
                      {{ $t("days") }}
                    </v-chip>
                    <v-chip small color="grey-lighten-1">
                      {{ strategy.num_executions }} {{ $t("executions") }}
                    </v-chip>
                  </v-col>
                  <v-col cols="12" md="1" class="d-flex justify-end">
                    <v-btn
                      icon
                      color="red"
                      @click.stop.prevent="showDeleteStrategy(strategy)"
                    >
                      <v-icon size="20">mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col
            cols="12"
            class="d-flex justify-center align-center mt-8"
            style="gap: 10px;"
          >
            <v-icon size="40">mdi-strategy</v-icon>
            <span class="text-body-1 font-weight-bold">
              {{ $t("no_strategies_found") }}
            </span>
          </v-col>
        </v-row>

        <!-- Add strategy -->
        <a-pricing-strategy-set-strategy-dialog
          @updatedStrategy="updatedStrategy"
        />

        <!-- Delete strategy -->
        <v-dialog
          v-model="show_delete_strategy"
          :fullscreen="$vuetify.breakpoint.xsOnly"
          max-width="400"
        >
          <v-card>
            <v-card-title center class="headline justify-center">
              {{ $t("are_you_sure") }}
            </v-card-title>
            <v-card-text
              class="text-center justify-center"
              v-if="strategy_to_delete"
              v-html="
                $t('sure_delete_pricing_strategy', {
                  strategy: strategy_to_delete.name
                })
              "
            >
            </v-card-text>
            <v-card-actions class="ps-5 pb-5 justify-center">
              <v-btn
                color="red"
                rounded
                depressed
                text
                class="pl-5 pr-5"
                @click="deleteStrategy()"
              >
                {{ $t("delete") }}
              </v-btn>
              <v-btn
                color=""
                text
                rounded
                depressed
                class="pl-5 pr-5"
                @click="hideDeleteStrategy"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:loading>
        <v-card>
          <v-card-text>
            <v-skeleton-loader type="table"> </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </template>
    </a-base-component>
  </div>
</template>

<script>
import aBaseComponent from "@/components/aBaseComponent";
import aPricingStrategySetStrategyDialog from "@/components/pricing-strategy/aPricingStrategySetStrategyDialog";
import * as Utils from "@/utils.js";
import { mapGetters, mapState } from "vuex";

export default {
  name: "a-pricing-strategy-strategies",
  components: {
    aBaseComponent,
    aPricingStrategySetStrategyDialog
  },
  data: () => ({
    subscribed_modules: [
      "pricingstrategy_strategies",
      "pricingstrategy_strategy_rates"
    ],
    search: "",
    show_delete_strategy: false,
    strategy_to_delete: null,
    loadingAddStrategy: false
  }),
  computed: {
    strategy_to_edit: {
      get() {
        return this.$store.state.pricingstrategy.strategy_to_edit;
      },
      set(value) {
        this.$store.dispatch("setPricingStrategyStrategyToEdit", value);
      }
    },
    set_strategy_dialog: {
      get() {
        return this.$store.state.pricingstrategy.set_strategy_dialog;
      },
      set(value) {
        this.$store.dispatch("setPricingStrategySetStrategyDialog", value);
      }
    },
    filteredStrategies() {
      let search = "";
      if (this.search) {
        search = this.search.toLowerCase();
      }
      return this.strategies.filter(strategy =>
        strategy.name.toLowerCase().includes(search)
      );
    },
    ...mapState({
      strategies: state => state.pricingstrategy.strategies,
      strategy_rates: state => state.pricingstrategy.strategy_rates
    }),
    ...mapGetters({
      current_hotel: "current_hotel"
    })
  },
  methods: {
    getStrategyRatesCode(id) {
      return this.strategy_rates.find(rate => rate.id === id)
        ? this.strategy_rates.find(rate => rate.id === id).code
        : "";
    },
    showDeleteStrategy(item) {
      if (!item) {
        return false;
      }
      this.show_delete_strategy = true;
      this.strategy_to_delete = item;
    },
    hideDeleteStrategy() {
      this.show_delete_strategy = false;
      this.strategy_to_delete = null;
    },
    deleteStrategy() {
      this.$store.dispatch("setSnackbar", {
        title: this.$t("deleting_strategy"),
        color: "secondary"
      });
      this.$store
        .dispatch("deletePricingStrategyStrategy", {
          strategy_id: this.strategy_to_delete.id
        })
        .then(() => {
          this.show_delete_strategy = false;
          this.$store.dispatch("setSnackbar", {
            title: this.$t("strategy_deleted"),
            color: "accent"
          });
          this.strategy_to_delete = null;
        })
        .catch(() => {
          this.show_delete_strategy = false;
          this.strategy_to_delete = null;
          Utils.showError(this, "strategy_not_deleted");
        });
    },
    showAddStrategy() {
      this.set_strategy_dialog = true;
      this.strategy_to_edit = {
        hotel_id: this.current_hotel.id,
        name: "",
        description: "",
        color: "#3498DB",
        rate_plan_id:
          this.strategy_rates && this.strategy_rates.length === 1
            ? this.strategy_rates[0].id
            : null
      };
    },
    updatedStrategy(strategy_id) {
      this.routeToStrategyDetail(strategy_id);
    },

    // Route to strategy detail ------------------------------------------------
    routeToStrategyDetail(strategy_id) {
      if (parseInt(this.$route.path.split("/").pop()) !== strategy_id) {
        this.$router.push({
          name: "pricing_strategy_strategy_detail",
          params: { strategy_id: strategy_id }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.strategy-card {
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #f5f5f5;
  }
}
</style>
